import axios from './base'
const url = `/launch`

// ================= 落地页/启动页管理（后端 LaunchService，tb_launch，/launch*） =================
// 产品规则：开屏落地页多版本，同一时间可启用多个，小程序取启用中的最新版；「了解更多」跳转地址留空=展开站内图文

// 版本列表（无分页；筛选 keyword 版本名称/宣传语 / status 1启用 0停用；启用中排前，再按更新时间倒序）
export function getLaunchList(params = {}) {
  return axios.request({
    url: `${url}`,
    method: "get",
    params,
  })
}

// 版本详情
export function getLaunchDetail(id, params = {}) {
  return axios.request({
    url: `${url}/${id}`,
    method: "get",
    params,
  })
}

// 新增版本（slogan 字符串数组；logo 可选；content 与 jump_url 至少一个）
export function createLaunch(data = {}) {
  return axios.request({
    url: `${url}`,
    method: "post",
    data,
  })
}

// 编辑版本
export function updateLaunch(id, data = {}) {
  return axios.request({
    url: `${url}/${id}`,
    method: "put",
    data,
  })
}

// 删除版本（软删）
export function deleteLaunch(id, data = {}) {
  return axios.request({
    url: `${url}/${id}`,
    method: "delete",
    data,
  })
}

// 启用 / 停用（data: { status: 1 }）
export function setLaunchStatus(id, data = {}) {
  return axios.request({
    url: `${url}/${id}/status`,
    method: "put",
    data,
  })
}
